import React from 'react';
import glamorous from 'glamorous';
import { FormattedMessage } from 'react-intl';

const Footer = ({ isSticky }) => (
  <glamorous.Footer css={isSticky ? {
    position: 'absolute',
    bottom: 0,
    height: 60,
  } : {}}>
    <div className="container notranslate">
      <FormattedMessage id="all.rights.reserved"/>
      <a href="http://www.oecd.org/termsandconditions/" target="_blank">
        <FormattedMessage id="terms.and.conditions"/>
      </a>
      {' | '}
      <a href="http://www.oecd.org/privacy/" target="_blank">
        <FormattedMessage id="privacy.policy"/>
      </a>
      {' | '}
      <a href="http://www.oecd.org/contact/" target="_blank">
        <FormattedMessage id="contact.us"/>
      </a>
      {' | '}
      <a href="http://www.oecd.org/document/0,3343,en_2649_201185_2509279_1_1_1_1,00.html" target="_blank">
        <FormattedMessage id="help.faq"/>
      </a>
      {' | '}
      <a href="https://www.oecd.org/login" target="_blank">
        <FormattedMessage id="my.oecd"/>
      </a>
      {' | '}
      <a href="http://www.oecd.org/sitemap/" target="_blank">
        <FormattedMessage id="site.map"/>
      </a>
    </div>
  </glamorous.Footer>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/views/footer.js